import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiBenefitsCalculateRatesMutationRequest,
  PostApiBenefitsCalculateRatesMutationResponse,
  PostApiBenefitsCalculateRates401,
  PostApiBenefitsCalculateRates403,
} from "../../../types/PostApiBenefitsCalculateRates";

export function getPostApiBenefitsCalculateRatesUrl() {
  return `/api/Benefits/calculate-rates` as const;
}

/**
 * {@link /api/Benefits/calculate-rates}
 */
export async function postApiBenefitsCalculateRates(
  data?: PostApiBenefitsCalculateRatesMutationRequest,
  config: Partial<
    RequestConfig<PostApiBenefitsCalculateRatesMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiBenefitsCalculateRatesMutationResponse,
    ResponseErrorConfig<
      PostApiBenefitsCalculateRates401 | PostApiBenefitsCalculateRates403
    >,
    PostApiBenefitsCalculateRatesMutationRequest
  >({
    method: "POST",
    url: getPostApiBenefitsCalculateRatesUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
